import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { useL } from "@/context/I18nContext";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const L = useL();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError(L("Le password non coincidono", "Passwords do not match", "Die Passwörter stimmen nicht überein")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(L("Password aggiornata. Ora puoi accedere.", "Password updated. You can now sign in.", "Passwort aktualisiert. Sie können sich jetzt anmelden."));
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={L("Reimposta password", "Reset password", "Passwort zurücksetzen")} subtitle={L("Inserisci il token ricevuto e la nuova password.", "Enter the token you received and your new password.", "Geben Sie den erhaltenen Token und Ihr neues Passwort ein.")}
      footer={<><Link to="/login" className="text-cyanx hover:text-white">← {L("Torna al login", "Back to login", "Zurück zur Anmeldung")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div><Label className="text-slate-300">Token</Label><Input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token" className="mt-1.5 bg-navy-paper border-white/10 font-mono text-xs" /></div>
        <div><Label className="text-slate-300">{L("Nuova password", "New password", "Neues Passwort")}</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1.5 bg-navy-paper border-white/10 h-11" /></div>
        <div><Label className="text-slate-300">{L("Conferma password", "Confirm password", "Passwort bestätigen")}</Label><Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" className="mt-1.5 bg-navy-paper border-white/10 h-11" /></div>
        {error && <p className="text-sm text-red-400" data-testid="reset-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full bg-gold text-navy hover:bg-gold-hover h-11 font-medium" data-testid="reset-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : L("Aggiorna password", "Update password", "Passwort aktualisieren")}
        </Button>
      </form>
    </AuthShell>
  );
}
